/* eslint-disable no-await-in-loop */
import axios from 'axios';
import { EventOccurrence } from '@groupForecaster/models';
import * as MutationTypes from './mutationTypes';

export const getNextPageProducts = async (commit, nextProductsUrl, cancelToken) => {
  let nextPageUrl = nextProductsUrl;
  while (nextPageUrl) {
    try {
      const response = await axios.get(nextPageUrl, { removeTrailingSlash: true, cancelToken });
      const { count, results } = response.data;
      const eventOccurrenceList = EventOccurrence.toInstanceList(results);
      commit(MutationTypes.EVENT_OCCURRENCE_CALENDAR_LIST_UPDATE, { eventOccurrenceList, count });
      nextPageUrl = response.data.next;
    } catch (error) {
      nextPageUrl = null;
      if (!axios.isCancel(error)) throw error;
    }
  }
};
